document.documentElement.classList.remove('no-js');
const rreToast=(message)=>{const el=document.getElementById('RreToast');if(!el)return;el.textContent=message;el.classList.add('show');clearTimeout(window.rreToastTimer);window.rreToastTimer=setTimeout(()=>el.classList.remove('show'),1800)};
document.addEventListener('click',event=>{
  const toggle=event.target.closest('[data-menu-toggle]');
  if(toggle){const menu=document.getElementById('MobileMenu');const open=menu.toggleAttribute('open');toggle.setAttribute('aria-expanded',String(open));}
});
document.querySelectorAll('.reviews-section').forEach(section=>{
  const track=section.querySelector('[data-review-track]');
  if(!track)return;
  const move=direction=>track.scrollBy({left:direction*Math.min(410,track.clientWidth*.85),behavior:'smooth'});
  section.querySelector('[data-review-prev]')?.addEventListener('click',()=>move(-1));
  section.querySelector('[data-review-next]')?.addEventListener('click',()=>move(1));
  const autoplay=()=>setInterval(()=>{if(track.scrollLeft+track.clientWidth>=track.scrollWidth-10)track.scrollTo({left:0,behavior:'smooth'});else move(1)},5500);
  let timer=autoplay();
  section.addEventListener('mouseenter',()=>clearInterval(timer));
  section.addEventListener('mouseleave',()=>{clearInterval(timer);timer=autoplay()});
});
document.querySelectorAll('.featured-carousel-section').forEach(section=>{
  const track=section.querySelector('[data-product-carousel]');
  if(!track)return;
  const move=direction=>track.scrollBy({left:direction*Math.min(620,track.clientWidth*.9),behavior:'smooth'});
  section.querySelector('[data-carousel-prev]')?.addEventListener('click',()=>move(-1));
  section.querySelector('[data-carousel-next]')?.addEventListener('click',()=>move(1));
});
document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
  const items=[...gallery.querySelectorAll('[data-gallery-image]')];
  const lightbox=document.querySelector('[data-product-lightbox]');
  if(!items.length||!lightbox)return;
  const image=lightbox.querySelector('[data-lightbox-image]');
  const closeButton=lightbox.querySelector('[data-lightbox-close]');
  const previousButton=lightbox.querySelector('[data-lightbox-prev]');
  const nextButton=lightbox.querySelector('[data-lightbox-next]');
  let currentIndex=0;
  let opener=null;
  const show=index=>{
    currentIndex=(index+items.length)%items.length;
    const thumbnail=items[currentIndex].querySelector('img');
    image.src=items[currentIndex].dataset.fullImage;
    image.alt=thumbnail?.alt||'';
  };
  const open=(index,button)=>{
    opener=button;
    show(index);
    lightbox.hidden=false;
    document.body.classList.add('lightbox-open');
    closeButton.focus();
  };
  const close=()=>{
    lightbox.hidden=true;
    image.src='';
    document.body.classList.remove('lightbox-open');
    opener?.focus();
  };
  items.forEach((item,index)=>item.addEventListener('click',()=>open(index,item)));
  closeButton.addEventListener('click',close);
  previousButton.addEventListener('click',()=>show(currentIndex-1));
  nextButton.addEventListener('click',()=>show(currentIndex+1));
  lightbox.addEventListener('click',event=>{if(event.target===lightbox||event.target.classList.contains('product-lightbox-stage'))close()});
  document.addEventListener('keydown',event=>{
    if(lightbox.hidden)return;
    if(event.key==='Escape')close();
    if(event.key==='ArrowLeft')show(currentIndex-1);
    if(event.key==='ArrowRight')show(currentIndex+1);
  });
  if(items.length<2){previousButton.hidden=true;nextButton.hidden=true;}
});
document.addEventListener('submit',async event=>{
  const form=event.target.closest('form[data-ajax-cart]');
  if(!form)return;
  event.preventDefault();
  const button=form.querySelector('[type="submit"]');
  button?.setAttribute('disabled','');
  try{
    const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
    if(!response.ok)throw new Error((await response.json()).description||'Unable to add item');
    const cart=await fetch(window.Shopify.routes.root+'cart.js').then(r=>r.json());
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    rreToast('Added to cart');
  }catch(error){rreToast(error.message)}finally{button?.removeAttribute('disabled')}
});
